import React, { useContext, useEffect, useState } from "react";
import Configurationcontext from "../../Context/ConfigrationContext/Configurationcontext";
import configurationAPI from "../../apis/configuration/configurationAPI";
import localStorageStore from "../../utils/localStorageStore";
import Configuration from "./Configuration";

const Index = () => {
  const configData = useContext(Configurationcontext);
  const [success, setSuccess] = useState(false);
  const [selectedLoc, setSelectedLoc] = useState(0);
  const [location, setLoaction] = useState([]);
  const [isApiInProgress, updateApiProgress] = useState(false);
  const [clientCurrentId, setClientCurrentId] = useState();

  useEffect(() => {
    asyncInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configData.saveConfiguration]);

  const asyncInit = async () => {
    try {
      const locationId = configData.lastLocationUpdated;
      await fetchLocationData(locationId);
      await fetchClientData();
      setSelectedLoc(locationId ?? 0);
      fetchConfigurationData(locationId ?? 0);
    } catch (e) {
      console.log(e);
    }
  };

  const fetchLocationData = async (locationId = 0) => {
    try {
      let res = await configurationAPI.getLocationList(locationId);
      configData.setLocationData(res);
      return res;
    } catch (e) {
      console.log(e);
    }
  };

  const fetchClientData = async () => {
    configurationAPI
      .getClientList(0)
      .then((data) => {
        configData.setClient(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchConfigurationData = async (locID) => {
    configurationAPI
      .getConfiguration(0, locID)
      .then((data) => {
        configData.emptyData();
        configData.setConfigrationProcesses(data.processes);
        configData.setConfigrationSpecialities(data.specialties);
        configData.setConfigprimaryDiagnosis(data.prim_diag_feed);
        configData.setConfigSecondaryDiagnosis(data.sec_diag_feed);
        configData.setConfigProcedures(data.procedure_feed);
        configData.setConfigEd(data.ed_em_feed);
        configData.setConfigModifier(data.modifier_feed);
        configData.setConfigPOA(data.poa_feed);
        configData.setConfigDrug(data.drug_feed);
        configData.setConfigSubSpeciality(data.subspecialties);
        configData.setConfigAuditOptions(data.audit_options);
        configData.setConfigFeedbackTypes(data.feedback_types);
        configData.setConfigHoldReasons(data.hold_reasons);
        configData.setConfigDisposition(data.dispositions);
        configData.setConfigResponsibleParties(data.responsible_parties);
        configData.setConfigPrimaryHealth(data.primary_health);
        configData.setConfigFacility(data.facility);
        configData.setFieldValidationConfig(data.chartFieldConfiguration);
        configData.setDoesLocationSupportProcessWiseCoding(data.doesLocationSupportProcessWiseCoding);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onLocationClick = (val) => {
    setSelectedLoc(val?.id ?? 0);
    fetchConfigurationData(val.id ?? 0);
  };

  useEffect(() => {
    fetchClientData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  const onChartListSettingSaveClick = async (data) => {
    try {
      updateApiProgress(true);
      const userId = localStorageStore.getLoggedInUserId;
      await configurationAPI.submitChartListSettings(data, userId);
      updateApiProgress(false);
      window.toastr.success("Chart list settings saved successfully");
    } catch (error) {
      updateApiProgress(false);
      console.log(error);
    }
  };

  return (
    <>
      <Configuration
        fetchConfigurationData={fetchConfigurationData}
        location={location}
        setLoaction={setLoaction}
        success={success}
        setSuccess={setSuccess}
        selectedLoc={selectedLoc}
        onLocationClick={onLocationClick}
        onChartListSettingSaveClick={onChartListSettingSaveClick}
        isApiInProgress={isApiInProgress}
        setClientCurrentId={setClientCurrentId}
        clientCurrentId={clientCurrentId}
      />
    </>
  );
};
export default Index;
